if (!customElements.get('fitwood-age-finder')) {
  customElements.define('fitwood-age-finder', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.choices = Array.from(this.querySelectorAll('[data-age-choice]'));
      this.panels = Array.from(this.querySelectorAll('[data-age-panel]'));
      if (!this.choices.length || !this.panels.length) return;
      this.classList.add('is-enhanced');
      let initial = this.dataset.defaultAge;
      const matchingHash = this.panels.find(panel => '#' + panel.id === location.hash);
      if (matchingHash) initial = matchingHash.dataset.agePanel;
      this.selectAge(initial, false);
      this.querySelectorAll('[data-age-video]').forEach(player => {
        const video = player.querySelector('video');
        if (video) {
          video.addEventListener('play', () => { player.querySelector('[data-age-video-play]').hidden = true; });
          video.addEventListener('pause', () => { player.querySelector('[data-age-video-play]').hidden = false; });
        }
      });
      this.addEventListener('click', event => {
        const play = event.target.closest('[data-age-video-play]');
        if (play) {
          const player = play.closest('[data-age-video]');
          const video = player.querySelector('video');
          if (video) video.play().catch(() => { play.hidden = false; });
          else {
            player.append(player.querySelector('template').content.cloneNode(true));
            play.hidden = true;
          }
          return;
        }
        const choice = event.target.closest('[data-age-choice]');
        if (!choice || !this.contains(choice)) return;
        event.preventDefault();
        this.selectAge(choice.dataset.ageChoice, true);
      });
      this.addEventListener('keydown', event => {
        const choice = event.target.closest('[data-age-choice]');
        if (!choice) return;
        const current = this.choices.indexOf(choice);
        let target;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') target = (current + 1) % this.choices.length;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') target = (current - 1 + this.choices.length) % this.choices.length;
        if (event.key === 'Home') target = 0;
        if (event.key === 'End') target = this.choices.length - 1;
        if (target !== undefined) {
          event.preventDefault();
          this.choices[target].focus();
          this.selectAge(this.choices[target].dataset.ageChoice, false);
        }
      });
      this.addEventListener('shopify:block:select', event => {
        const choice = event.target.closest('[data-age-choice]');
        if (choice) this.selectAge(choice.dataset.ageChoice, true);
      });
    }
    selectAge(age, scroll) {
      const panel = this.panels.find(item => item.dataset.agePanel === age) || this.panels[0];
      this.choices.forEach(choice => {
        const selected = choice.dataset.ageChoice === panel.dataset.agePanel;
        choice.classList.toggle('is-active', selected);
        if (selected) choice.setAttribute('aria-current', 'true');
        else choice.removeAttribute('aria-current');
      });
      this.panels.forEach(item => {
        item.hidden = item !== panel;
        if (item !== panel) {
          item.querySelectorAll('video').forEach(video => video.pause());
          item.querySelectorAll('[data-age-video] iframe').forEach(frame => frame.remove());
          item.querySelectorAll('[data-age-video-play]').forEach(button => { button.hidden = false; });
        }
      });
      if (scroll) {
        history.replaceState(null, '', '#' + panel.id);
        panel.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start'});
      }
    }
  });
}
